import * as Yup from 'yup'

import { TCustomer } from '../data/mutations'

export const baseValidationSchema = Yup.object().shape({
  apiKey: Yup.string().required('API Key is required')
})

export const validationSchema = (id: string | number) =>
  Yup.object().shape({
    [`customerID-${id}`]: Yup.string().required('Bill To (Customer ID) is required'),
    [`customerIDInChaine-${id}`]: Yup.string().test(
      'customerIDInChaine-or-customerNameInChaine-required',
      'Either customerIDInChaine or customerNameInChaine is required',
      function (value) {
        return Boolean(value || this.parent[`customerNameInChaine-${id}`]) // Pass validation if either 'a' or 'b' exists
      }
    ),
    [`customerNameInChaine-${id}`]: Yup.string().test(
      'customerIDInChaine-or-customerNameInChaine-required',
      'Either customerIDInChaine or customerNameInChaine is required',
      function (value) {
        return Boolean(value || this.parent[`customerIDInChaine-${id}`])
      }
    )
  })

export const getGroupStructure = (
  uniqueID: string | number,
  disabled?: boolean,
  integrationConfigurationID?: string
) => {
  return {
    [uniqueID]: [
      {
        disabled: disabled || false,
        integrationConfigurationID: integrationConfigurationID || '',
        isRequired: true,
        labelText: 'CustomerID ( Bill To )',
        name: `customerID-${uniqueID}`,
        placeholder: 'Enter customer\'s "Bill To" from FourKites'
      },
      {
        disabled: disabled || false,
        integrationConfigurationID: integrationConfigurationID || '',
        labelText: 'Customer Name ( In Chaine )',
        name: `customerNameInChaine-${uniqueID}`,
        placeholder: "Enter the customer's name in Chaine"
      },
      {
        disabled: disabled || false,
        integrationConfigurationID: integrationConfigurationID || '',
        labelText: 'Customer ID ( In Chaine )',
        name: `customerIDInChaine-${uniqueID}`,
        placeholder: "Enter the customer's ID in Chaine"
      }
    ]
  }
}

export function endsWithUUID(str: string) {
  const uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  return uuidRegex.test(str)
}

export const getPayloadStructure = (event: Record<string, string>): { apiKey: string; customers: TCustomer[] } => {
  const result: Record<string, string | TCustomer[]> = {
    apiKey: event.apiKey,
    customers: []
  }
  const customerData: Record<string, TCustomer> = {}
  for (const [key, value] of Object.entries(event)) {
    const match = key.match(/(customerID|customerNameInChaine|customerIDInChaine)-(.+)/)
    if (match) {
      const [, property, id] = match
      if (!customerData[id]) {
        customerData[id] = {
          customerID: '',
          customerIDInChaine: null,
          customerNameInChaine: null
        } as TCustomer
      }
      customerData[id][property as keyof TCustomer] = value
    }
  }
  result.customers = Object.values(customerData)
  return result as { apiKey: string; customers: TCustomer[] }
}

export const getInitialValues = ({ apiKey, customers }: { apiKey: string; customers: TCustomer[] }) => {
  const customersValueMap = customers.reduce(
    (acc: Record<string, string | undefined>, customer: TCustomer, index: number) => {
      acc[`customerID-${index + 1}`] = customer.customerID
      acc[`customerNameInChaine-${index + 1}`] = customer.customerNameInChaine || undefined
      acc[`customerIDInChaine-${index + 1}`] = customer.customerIDInChaine || undefined
      return acc
    },
    {}
  )
  return {
    apiKey: apiKey,
    ...customersValueMap
  }
}
